module.exports = __webpack_public_path__ + "img/avatar.e1fb742f.svg";